import { FC } from 'react';

import AuthenticationLayout from '@/components/layout/AuthenticationLayout.tsx';
import ResetPasswordForm from '@/components/layout/forgotPasswordPage/ResetPasswordForm.tsx';

const ForgotPassword: FC = () => {
  return (
    <AuthenticationLayout>
      <ResetPasswordForm />
    </AuthenticationLayout>
  );
};

export default ForgotPassword;
